import { Pipe, PipeTransform } from "@angular/core";
import { Driver } from "src/app/model/driver.model";

/**
 * Get the names of drivers for display.
 */
@Pipe({
  name: 'driverName'
})
export class DriverNamePipe implements PipeTransform {
  public transform(args: Driver | Driver[]) {
    const drivers = args instanceof Array
      ? args
      : [args];
    
    return drivers.reduce((names, driver, index, self) => {
      const name = `${driver.first_name} ${driver.last_name}`;

      if(index === 0) {
        return name;
      }
      else if(index + 1 === self.length) {
        return `${names} and ${name}`;
      }
      else {
        return `${names}, ${name}`;
      }
    }, '');
  }
}
